import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../layout/header";
import Footer from "../../layout/footer";
import { Button, Card, Col, Container, InputGroup, Row, Spinner } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import mastercardLogo from './mastercrd.png';
import { loadFromLocalStorage } from "utils/LocalStorageUtils";
import { apiCall } from "utils/httpClient";
import apiEndPoint from "utils/apiEndPoint";
import { failedMessage } from "utils/httpClient";
import { successMessage } from "utils/httpClient";
import { isEmpty } from "utils/utils";

function ResetPassword({handleClose}) {

  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    password: '',
    cpassword: '',
  });
  const [errorMessage, setErrorMessage] = useState({});
  const [userData, setUserData] = useState({});
  const [profileImage, setProfileImage] = useState(null);
  const [isLoading, setLoading] = useState(false);
  useEffect(() => {
    const authData = loadFromLocalStorage("AUTH_DATA");
    if (authData) {
      setUserData(authData.userDetail)
    }
  }, []);




  const validation = () => {
    let isError = true;
    let errorMessage = {};
    if (isEmpty(passwordData?.oldPassword)) {
      isError = false;
      errorMessage["oldPassword"] = "Please enter old password";
    }
    if (isEmpty(passwordData?.password)) {
      isError = false;
      errorMessage["password"] = "Please enter password";
    }
    if (isEmpty(passwordData?.cpassword)) {
      isError = false;
      errorMessage["cpassword"] = "Please enter retype password";
    } else if (passwordData?.password !== passwordData?.cpassword) {
      isError = false;
      errorMessage["cpassword"] = "Password and retype password not match!";
    }

    setErrorMessage(errorMessage);
    return isError;
  };
  const handleChange = async () => {
    if (validation()) {
      setLoading(true)
      const params = {
        old_password: passwordData?.oldPassword,
        new_password: passwordData?.password,
      }
      const { data } = await apiCall('post', apiEndPoint.CHANGEPASSWORD, params);
      if (data.status !== 200) {
        failedMessage(data.message);
      } else {
        successMessage(data.message)
        handleClose()
        setPasswordData({
          oldPassword: '',
          password: '',
          cpassword: '',
        })
      }
      setLoading(false)
    }
  }

  return (
    <div>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 18, fontWeight: 600 }}>Change your password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="formGroupPassword">
            <Form.Label>Old Password</Form.Label>
            <Form.Control type="password" placeholder="Old Password"
              value={passwordData?.oldPassword}
              onChange={(e) => setPasswordData({
                ...passwordData,
                oldPassword: e.target.value
              })}
              error={true}
            />
            {errorMessage.oldPassword && <span className="er-msg-show">{errorMessage.oldPassword}</span>}
          </Form.Group>
          <Form.Group className="mb-3" controlId="formGroupPassword">
            <Form.Label>New Password</Form.Label>
            <Form.Control type="password" placeholder="New Password"
              value={passwordData?.password} onChange={(e) => setPasswordData({
                ...passwordData,
                password: e.target.value
              })}
            />
            {errorMessage.password && <span className="er-msg-show">{errorMessage.password}</span>}
          </Form.Group>
          <Form.Group className="mb-3" controlId="formGroupPasswordRetype">
            <Form.Label>Retype Password</Form.Label>
            <Form.Control type="password" placeholder="Retype Password"
              value={passwordData?.cpassword}
              onChange={(e) => setPasswordData({
                ...passwordData,
                cpassword: e.target.value
              })} />
            {errorMessage.cpassword && <span className="er-msg-show">{errorMessage.cpassword}</span>}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button style={{ margin: '5px', borderRadius: 15, width: 'inherit', fontSize: 12, fontWeight: 500 }} size='md' variant="secondary" onClick={handleClose}>
          Back
        </Button>
        <Button style={{ margin: '5px', borderRadius: 15, width: 'inherit', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }} size='md' onClick={() => handleChange()} >
          {isLoading ? <Spinner animation="border" size="sm" role="status" /> : 'Confirm'}
        </Button>
      </Modal.Footer>
    </div>
  );
}

export default ResetPassword;
